import React, { useEffect } from "react";
import AudienceGenderChart from "./AudienceGenderChart";
import NoData from "../NoData/NoData";
import Loading from "../Loading/Loading";

function AudienceByGender(props) {
    const chartLoading = props.chartDataLoading?.audience_metrics_by_gender;
    const isNoData = props.pageStatus || Object.keys(props.chartData.audience_metrics_by_gender || {}).length === 0;

    useEffect(() => {
        props.setIsNoDataState(isNoData);
    }, [props.chartData, props.pageStatus]);

    const emptyObject = () => {
        const chartData = props.chartData.audience_metrics_by_gender || {};
        const chartDataLength = Object.keys(chartData).length === 0;
        props.setIsNoDataState(chartDataLength);
        return chartDataLength;
    };

    return (
        <>
            {chartLoading && <Loading />}
            {!emptyObject() && !chartLoading && (
                <AudienceGenderChart
                    chartData={props.chartData.audience_metrics_by_gender}
                    graphType={props.graphType}
                    showLegend={props.showLegend}
                    showGridLines={props.showGridLines}
                    showLabel={props.showLabel}
                    isIGPage={props.isIGPage}
                    widgetContainerRef={props.widgetContainerRef}
                />
            )}
            {emptyObject() && !chartLoading && <NoData message={props.pageStatus ? "Page is Inactive. Please re-authenticate" : ""} />}
        </>
    );
}
export default AudienceByGender;
